import React from 'react';

const ChannelTypes = () => {
  return (
    <React.Fragment>
      <h1>Channel Types</h1>
      <p>
        Cureus offers three distinct types of publication channels, each designed to suit different institutional and commercial partnerships: <strong>Academic, Academic (Non-subscription),</strong> and <strong>Commercial.</strong>
      </p>
      <p>
        <strong>Academic Channels</strong> include Channel Administrators and Channel Curators, who take an active role in managing the channel homepage and overseeing the publication process, thereby ensuring that all submissions are within scope and adhering to journal guidelines.
      </p>
      <p>
        <strong>Academic (Non-subscription) and Commercial Channels</strong> do not include Channel Admins or Channel Curators, as there is no channel staff involvement with article submissions beyond confirming that the author is eligible to submit through the channel and that the topic is within the channel’s scope. This task is performed by Channel Screeners.
      </p>
      <p>
        All Channel Admins, Channel Curators and Channel Screeners are vetted by Cureus prior to their participation.
      </p>
      <p>
        The key difference between Academic (Non-subscription) and Commercial Channels is author payment. Commercial Channels are similar to Academic Channels in that the organization purchases a subscription enabling their authors to publish with zero fees. Meanwhile, articles submitted to Academic Channels (Non-subscription) can still be deferred for PE with the author responsible for purchasing Preferred Editing at a discount. This allows organizations to subsidize the cost of publishing for their authors without committing to a yearly subscription. A one-time startup fee is required for Academic Channels (Non-subscription).
      </p>
      <p>
        Regardless of channel type, <strong>Independent Cureus editors (associate editors)</strong> review all submissions and requests for publication, determine whether authors have applied necessary changes, and make the final decision regarding whether to publish or reject channel articles. The editorial decision-making process for channel articles does not include, nor is it influenced by, the Channel Admins or Curators.
      </p>
      <p>
        The following flowcharts provide a high-level overview of the publication process for articles submitted through each channel type:
      </p>
      <img src='https://public.cureus.com/channels_guide/Academic%20Channels%20flow%20chart.png' />
      <img src='https://public.cureus.com/channels_guide/PE%20%26%20Commercial%20Channels%20%20flow%20chart.png' />
    </React.Fragment>
  )
};

export default ChannelTypes;